import { render, staticRenderFns } from "./RegistrationFieldsEditor.vue?vue&type=template&id=26f3eaec&scoped=true&"
import script from "./RegistrationFieldsEditor.vue?vue&type=script&lang=js&"
export * from "./RegistrationFieldsEditor.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFieldsEditor.vue?vue&type=style&index=0&id=26f3eaec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f3eaec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
